'use client';

import Image from 'next/image';
import styles from './style.module.scss';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';

const Card = ({
  i,
  title,
  description,
  src,
  url,
  color = '#db2777',
  progress,
  range,
  duration,
  price
}) => {
  const container = useRef(null);

  const { scrollYProgress } = useScroll({
    target: container,
    offset: ['start end', 'start start']
  });

  const y = useTransform(progress, range, [i * 30, 0]);
  const rotateY = useTransform(progress, range, [6 * (i + 1), 0]);

  return (
    <motion.div
      ref={container}
      className={styles.cardContainer}
      style={{
        y,
        rotateY,
        zIndex: i + 1  // cards with higher i will be on top
      }}
      whileHover={{
        rotateY: 0,
        y: 0
      }}
      transition={{
        type: 'spring',
        stiffness: 300,
        damping: 24
      }}
    >
      <div className={styles.card} style={{ borderColor: color }}>
        <motion.div className={styles.imageWrapper}>
          {/* Use src directly if it’s a full URL */}
          <Image
            src={src}
            alt={title}
            fill
            className={styles.image}
          />
          <div className={styles.colorOverlay} style={{ backgroundColor: `${color}88` }} />
        </motion.div>

        <div className={styles.content}>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.tagline}>
            {description.length > 150 ? description.slice(0, 150) + '...' : description}
          </p>

          <div className={styles.details}>
            <div><strong>⏰ Duration:</strong> {duration}</div>
            <div><strong>💰 Price:</strong> {price}</div>
          </div>

          <a href={url} target="_blank" rel="noopener noreferrer" className={styles.ctaButton}>
            Book Your Session
          </a>
        </div>
      </div>
    </motion.div>
  );
};

export default Card;
